import React, { memo } from 'react';

import { SkeletonSimple } from '~components/skeleton';

const FiltersSkeleton = memo(() => {
  return <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__filters" />;
});

export default FiltersSkeleton;
